
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form
} from "reactstrap";
import TenantService from "../../../services/tenantService";
import TenantForm from "./Form";

class TenantEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorData: {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { uniqueId } = this.props.match.params;
    TenantService.fetch(uniqueId).then(response => {
      this.setState(response.data);
      this.setState({ uniqueId: uniqueId });
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    TenantService.update(this.state).then(response => {
      if (response.responseStatus === "SUCCESS") {
        this.props.history.push("/superAdmin/tenant/list");
      } else {
        this.setState({ errorData: response.data });
        console.error("Error    ==>     " + response.message);
      }
    });
  }

  render() {
    return (
      <>
        <SimpleHeader
            name="Edit"
            parentName="Tenant"
            heading="ClashMate"
            newBtnUrl="/superAdmin/tenant/create"
            newBtnText="Create Tenant"
        />
        <Container className="mt--6" fluid>
          <Card className="mb-4">
            <CardHeader>
              <h3 className="mb-0">Edit Tenant</h3>
            </CardHeader>
            <CardBody>
              <Form role="form" onSubmit={this.handleSubmit}>
                <TenantForm
                  onChange={this.handleChange}
                  valueObj={this.state}
                  errorObj={this.state.errorData}
                  isEdit={true}
                />
                <div className="text-center">
                  <Button className="my-4" color="info" type="submit">
                    Update
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}

export default TenantEdit;
